import { gql } from '@apollo/client';

export const GET_APP_CFG = gql`
  query GetAppCfgs($teamId: String!, $appType: String!) {
    getAppCfgs(teamId: $teamId, appType: $appType)
  }
`;
